import './index.scss';

import iconeagro from "../../assets/icons/ico-agro.svg";
import iconebarco from "../../assets/icons/ico-barco.svg";
import iconefuel from "../../assets/icons/ico-fuel.svg";
import iconemasspayment from "../../assets/icons/ico-masspayment.svg";
import iconeplug from "../../assets/icons/ico-plug.svg";

import React from 'react';
import { Icon } from '../../components/icon';

export const NichosDeMercado = () => {

    return (

        <div className='container-page6'>

            <div className='container-1-page6'>
                <h2> Para nós, cada cliente é único </h2>
                <p>
                    Entendemos que o mercado global tem diversas peculiaridades e por isso
                    nos preocupamos com as necessidades específicas dos nichos de mercado
                </p>
            </div>

            <div className='container-2-page6'>
                <div className="item 1">
                    <div className="img">
                        <Icon icon={iconebarco} size={50}/>
                    </div>
                    <h1 className='title'>Importação e Exportação</h1>
                </div>
                <div className="item 2">
                    <div className="img">
                        <Icon icon={iconefuel} size={40}/>
                    </div>
                    <h1 className='title'>Combustíveis</h1>
                </div>
                <div className="item 3">
                    <div className="img">
                        <Icon icon={iconeagro} size={40}/>
                    </div>
                    <h1 className='title'>Agronegócio e Pecuária</h1>
                </div>
                <div className="item 4">
                    <div className="img">
                        <Icon icon={iconeplug} size={40}/>
                    </div>
                    <h1 className='title'>Energia</h1>
                </div>
                <div className="item 5">
                    <div className="img">
                        <Icon icon={iconemasspayment} size={40}/>
                    </div>
                    <h1 className='title'>Masspayments</h1>
                </div>
            </div>

        </div>

    )

}
